export default __webpack_public_path__ + "static/media/katia-silene-book.6846647c.png";